var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 384",
    style: {
      enableBackground: "new 0 0 384 384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272,32c21.2,0,41.3,8.4,56.5,23.5S352,90.8,352,112v160c0,21.2-8.4,41.3-23.5,56.5S293.2,352,272,352H112 c-21.2,0-41.3-8.4-56.5-23.5S32,293.2,32,272V112c0-21.2,8.4-41.3,23.5-56.5S90.8,32,112,32H272 M272,0H112C50.4,0,0,50.4,0,112v160 c0,61.6,50.4,112,112,112h160c61.6,0,112-50.4,112-112V112C384,50.4,333.6,0,272,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,112c-13.3,0-24-10.7-24-24s10.7-24,24-24c13.2,0,24,10.7,24,24S309.2,112,296,112z M192,128 c35.3,0,64,28.7,64,64s-28.7,64-64,64s-64-28.7-64-64S156.7,128,192,128 M192,96c-53,0-96,43-96,96s43,96,96,96s96-43,96-96 S245,96,192,96z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7951df5dbed2a873e50fa768d7b0455c.svg";
export { ForwardRef as ReactComponent };